import { extendTheme, ThemeConfig } from '@chakra-ui/react';
import { createBreakpoints } from '@chakra-ui/theme-tools';
import { colors } from './colors';
import { Container } from './components/Container';
import { styles } from './global';

const breakpoints = createBreakpoints({
  sm: '320px',
  md: '768px',
  lg: '960px',
  xl: '1200px',
  '2xl': '1440px',
});

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
  cssVarPrefix: 'crypto',
};

const theme = extendTheme({
  config,
  styles,
  colors,
  breakpoints,
  fonts: {
    body: 'Nunito Sans',
    heading: 'Nunito Sans',
  },
  components: {
    Container,
  },
});

export default theme;
